import { ProjectSecretService } from "src/app/shared/services/project-secret.service";
import { RouteShareService } from "src/app/shared/services/route-share.service";
import { BlocklyHelperService } from "../blockly-helper.service";
import { BLOCKLY_BLOCK_PREFIX, BLOCKLY_COLORS, BLOCKLY_DUMMY, BlocklyToolboxCategory, PROPERTIES_FOR_STRING_JOIN_ITEM } from "../blocky-types.types";

import * as Blockly from "blockly/core";
import { BlocklyCategory_VARIABLES_magic } from "./variables.magic.category";
import { registerStackBlock } from "../field-stack-dropdown";
export function BlocklyCategory_COMMON(name: string = "unnamed", BH: BlocklyHelperService, rss: RouteShareService, secretService: ProjectSecretService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', colour: BLOCKLY_COLORS.CAT_DATEN_INHALTE, name: name, contents: [] };



  const generalBlockStle = { colour: BLOCKLY_COLORS.PROPERTIES };
  const blocks = [

    { checkType: 'WEBHOOK', text: 'Webbhook', options: rss._allWebhooks() },
    { checkType: 'DATABASE', text: 'Datenbank', options: rss._allDataBases() },
    { checkType: 'WENNDANN', text: 'Wenn-Dann', options: rss._allWennDann() },
    { checkType: 'ONLINESOURCE', text: 'Onlinequellen', options: rss._allOnlineSources() },
    { checkType: 'OFFLINEWEBSITE', text: 'Offline-Websites', options: rss._allOfflineWebsites() },
    { checkType: 'FUSIONVIEW', text: 'Fusion-View', options: rss._allFusionViews() },
    { checkType: 'STAGE', text: 'Stage', options: rss._allStages() },
    { checkType: 'PROJECTSECRET', text: 'Projekt-Secret', options: secretService.projectSecrets.map(s => s.name) },
    { checkType: 'SKILL', text: 'Skill', options: rss._allSkills() }
  ];

  const variableMenu = BlocklyCategory_VARIABLES_magic("Variablen", BH);



  //  Blockly.Msg['RENAME_VARIABLE'] = 'Variable "%1" umbenennen';
  //Blockly.Msg['DELETE_VARIABLE'] = 'Variable "%1" löschen';
  Blockly.Msg['TEXT_JOIN_TITLE_CREATEWITH'] = 'Texte verbinden';
  Blockly.Msg['TEXT_JOIN_TITLE_CREATEWITH'] = 'Texte verbinden';
  Blockly.Msg['TEXT_JOIN_TOOLTIP'] = 'Erstelle einen Text, indem du beliebig viele Elemente verbindest.';
  Blockly.Msg['TEXT_CREATE_JOIN_TITLE_JOIN'] = 'verbinden';
  Blockly.Msg['TEXT_CREATE_JOIN_TOOLTIP'] = 'Abschnitte hinzufügen, entfernen oder neu anordnen, um diesen Textblock zu konfigurieren.';
  Blockly.Msg['TEXT_CREATE_JOIN_ITEM_TITLE_ITEM'] = 'Element';
  Blockly.Msg['TEXT_APPEND_VARIABLE'] = 'Element';
  Blockly.Msg['TEXT_APPEND_TEXT'] = 'Text anhängen';
  Blockly.Msg['TEXT_APPEND_TOOLTIP'] = 'Hängt Text an die Variable \'%1\' an.';
  Blockly.Msg['TEXT_LENGTH_TITLE'] = 'Länge von %1';
  Blockly.Msg['TEXT_LENGTH_TOOLTIP'] = 'Gibt die Anzahl der Buchstaben (einschließlich Leerzeichen) im angegebenen Text zurück.';
  Blockly.Msg['TEXT_ISEMPTY_TITLE'] = '%1 ist leer';
  Blockly.Msg['TEXT_ISEMPTY_TOOLTIP'] = 'Gibt \'wahr\' zurück, wenn der angegebene Text leer ist.';
  Blockly.Msg['TEXT_INDEXOF_TITLE'] = 'im Text %1 %2 %3';
  Blockly.Msg['TEXT_INDEXOF_OPERATOR_FIRST'] = 'erstes Vorkommen des Textes finden';
  Blockly.Msg['TEXT_INDEXOF_OPERATOR_LAST'] = 'letztes Vorkommen des Textes finden';
  Blockly.Msg['TEXT_INDEXOF_TOOLTIP'] = 'Gibt die Position des ersten/letzten Auftretens des ersten Textes im zweiten Text zurück. Gibt 0 zurück, wenn der Text nicht gefunden wird.';
  Blockly.Msg['TEXT_CHARAT_TITLE'] = 'im Text %1 %2';
  Blockly.Msg['TEXT_CHARAT_TOOLTIP'] = 'Gibt den Buchstaben an der angegebenen Position zurück.';
  Blockly.Msg['TEXT_GET_SUBSTRING_TITLE'] = 'Teiltext von %1 von %2 bis %3';
  Blockly.Msg['TEXT_GET_SUBSTRING_TOOLTIP'] = 'Gibt den angegebenen Teil des Textes zurück.';
  Blockly.Msg['TEXT_CHANGECASE_TITLE'] = '%1 %2';
  Blockly.Msg['TEXT_CHANGECASE_OPERATOR_UPPERCASE'] = 'in GROSSBUCHSTABEN';
  Blockly.Msg['TEXT_CHANGECASE_OPERATOR_LOWERCASE'] = 'in kleinbuchstaben';
  Blockly.Msg['TEXT_CHANGECASE_OPERATOR_TITLECASE'] = 'in Titel-Schreibweise';
  Blockly.Msg['TEXT_CHANGECASE_TOOLTIP'] = 'Gibt eine Kopie des Textes in anderer Groß-/Kleinschreibung zurück.';
  Blockly.Msg['TEXT_TRIM_TITLE'] = '%1 %2';
  Blockly.Msg['TEXT_TRIM_OPERATOR_BOTH'] = 'Leerzeichen an beiden Enden entfernen';
  Blockly.Msg['TEXT_TRIM_OPERATOR_LEFT'] = 'Leerzeichen am Anfang entfernen';
  Blockly.Msg['TEXT_TRIM_OPERATOR_RIGHT'] = 'Leerzeichen am Ende entfernen';
  Blockly.Msg['TEXT_TRIM_TOOLTIP'] = 'Gibt eine Kopie des Textes mit entfernten Leerzeichen von einem oder beiden Enden zurück.';
  Blockly.Msg['TEXT_PRINT_TITLE'] = '%1 ausgeben';
  Blockly.Msg['TEXT_PRINT_TOOLTIP'] = 'Gibt den angegebenen Text, die Zahl oder einen anderen Wert aus.';
  Blockly.Msg['TEXT_PROMPT_EXT_TITLE'] = '%1 mit Nachricht %2 abfragen';
  Blockly.Msg['TEXT_PROMPT_EXT_TOOLTIP'] = 'Fragt den Nutzer mit einer bestimmten Nachricht nach Eingaben.';



  cat.contents = [
    BH.label("Freie Inhalte"),

    BH.number(BLOCKLY_DUMMY.NUMBER, 0),
    BH.text(BLOCKLY_DUMMY.URL, "Url:", "https://...", "", "URL"),
    BH.boolean(BLOCKLY_DUMMY.BOOLEAN),
    BH.label("Formatierung"),
    BH._custom("HTML_TAG", "@output:String\n " + BLOCKLY_BLOCK_PREFIX.STYLINGS + "{{tag:dropdown=Fett|b,Kursiv|i,Unterstichen|u,Überschrift 1|h1,Überschrift 2|h2,Überschrift 3|h3,Überschrift 4|h4,Überschrift 5|h5,Überschrift 6|h6}}: {{code}}", "\"<{{tag}}>\"+{{code}}+\"</{{tag}}>\"", { colour: BLOCKLY_COLORS.STYLING }),

    //@ts-ignore
    ...variableMenu.contents,
    BH.label("Vordefinierte Inhalte")
  ];
  cat.contents.push(BH.withNested(
    BH._custom("_IMAGE_URL_BY_SKILL_ID", "@output:URL\nURL von: {{skillId[@check=IMAGE]}}", "(await RAGAI.HELPER.getImageURlFromSkill({{skillId}})) || ''", { colour: BLOCKLY_COLORS.PROPERTIES }),
    [{ forValue: 'skillId', isShadow: true, targetBlockType: 'BLOCK_STACK_IMAGE' }]
  ));

  // Inhaltsvariablen (templateVars) blocks
  const templateVarsString = (rss.botConfig.templateVars ?? []).filter(v => v.type === 'string').map(v => v.name);
  const templateVarsNumber = (rss.botConfig.templateVars ?? []).filter(v => v.type === 'number').map(v => v.name);
  const templateVarsBoolean = (rss.botConfig.templateVars ?? []).filter(v => v.type === 'boolean').map(v => v.name);

  if (templateVarsString.length > 0 || templateVarsNumber.length > 0 || templateVarsBoolean.length > 0) {
    cat.contents.push(BH.label("Inhaltsvariablen"));
  }

  if (templateVarsString.length > 0) {
    cat.contents.push(
      BH._custom("TEMPLATEVAR_TEXT", "@output:String\n📝Inhaltsvariable (Text):{{value:dropdown=" + templateVarsString.join(",") + "}}", "(RAGAI.BOTMANAGER.botConfig.templateVars || []).find(v => v.name === '{{value}}')?.value ?? ''", generalBlockStle)
    );
  }

  if (templateVarsNumber.length > 0) {
    cat.contents.push(
      BH._custom("TEMPLATEVAR_NUMBER", "@output:Number\n🔢Inhaltsvariable (Zahl):{{value:dropdown=" + templateVarsNumber.join(",") + "}}", "Number((RAGAI.BOTMANAGER.botConfig.templateVars || []).find(v => v.name === '{{value}}')?.value) || 0", generalBlockStle)
    );
  }

  if (templateVarsBoolean.length > 0) {
    cat.contents.push(
      BH._custom("TEMPLATEVAR_BOOLEAN", "@output:Boolean\n✅Inhaltsvariable (Boolean):{{value:dropdown=" + templateVarsBoolean.join(",") + "}}", "Boolean((RAGAI.BOTMANAGER.botConfig.templateVars || []).find(v => v.name === '{{value}}')?.value)", generalBlockStle)
    );
  }


  // Neuer einheitlicher BLOCK_STACK mit abhängigen Dropdowns
  registerStackBlock(rss, secretService);
  cat.contents.push({ kind: 'block' as const, type: 'BLOCK_STACK' });

  // Alte BLOCK_STACK_*-Blöcke nur noch registrieren (Abwärtskompatibilität), nicht in Toolbox anzeigen
  blocks.filter((block) => block.checkType !== "STAGE" && block.checkType !== "SKILL").forEach((block) => {
    if (block.options.length === 0) {
      block.options = ["???"];
    }
    if (block.checkType === "DOCUMENT_CONTENT") {
      BH._custom("BLOCK_STACK_" + block.checkType, "@output:String\n" + block.text + ":{{value:dropdown=" + block.options.join(",") + "}}", "(await RAGAI.DOWNLOAD.getMDContent('{{value}}')).content", generalBlockStle);
    } else {
      BH._custom("BLOCK_STACK_" + block.checkType, "@output:" + block.checkType + "\n" + block.text + ":{{value:dropdown=" + block.options.join(",") + "}}", "'{{value}}'", generalBlockStle);
    }
  });

  return cat;

}
